<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="row">
                    <div class="col-lg-3 col-md-6 position-relative">
                        <div class="d-flex align-items-center position-absolute btm-0">
                            <div>
                                <h3 class="font-medium">
                                    {{contract.contract_number}}
                                </h3>
                                <span>Contract No</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 position-relative">
                        <div class="d-flex align-items-center position-absolute btm-0">
                            <div>
                                <h3 class="font-medium m-b-0">{{contract.owner.biz_name}}</h3>
                                <span v-if="contract.type === 'SALE'">Seller</span>
                                <span v-if="contract.type === 'PURCHASE'">Buyer</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 position-relative">
                        <div class="ml-auto position-absolute btm-0">
                            <div>
                                <h3 class="font-medium" v-if="contract.member_did && contract.member_catalog">
                                    <did-details class="mb-n4" :catalog="contract.member_catalog" :did="contract.member_did"
                                                 :show_blockie="false"></did-details>
                                </h3>
                                <h3 class="font-medium m-b-0" v-else>{{contract.counterparty.biz_name}}</h3>
                                <span class="text-right"
                                      v-if="contract.member_did && contract.member_catalog">Member</span>
                                <span class="text-right" v-else-if="contract.type === 'PURCHASE'">Seller</span>
                                <span class="text-right" v-else-if="contract.type === 'SALE'">Buyer</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-1 col-md-6 position-relative">
                        <div class="d-flex align-items-center position-absolute btm-0">
                            <div>
                                <h3>
                                    <span class="label label-cyan" v-if="contract.status === 'DRAFT'">Draft</span>
                                    <span class="label label-indigo"
                                          v-if="contract.status === 'POSTED'">Posted</span>
                                    <span class="label label-dark-green" v-if="contract.status === 'CONFIRMED'">Confirmed</span>
                                    <span class="label label-grey" v-if="contract.status === 'VOID'">Void</span>
                                </h3>
                                <span>Status</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-2 col-md-6 position-relative text-right">
                        <div class="ml-auto  btm-0">
                            <div>
                                <h3 class="font-medium text-right m-b-0">
                                    <i class="fas fa-credit-card text-primary" v-if="contract.type === 'SALE'"/>
                                    <i class="fas fa-cart-arrow-down text-cyan" v-else/>
                                    {{contract.type || '-' | capitalize}}
                                </h3>
                                <span class="text-right">Contract Type</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row m-t-25">
            <div class="col-md-8">
                <marketplace-contract-overview :contract="contract"
                                               v-if="contract.type"></marketplace-contract-overview>
                <marketplace-contract-items :contract="contract"></marketplace-contract-items>
                <marketplace-payment-terms v-if="contract.type" :contractTotal="contract.total" :contractType="contract.type"
                                           :contractid="contractid" :marketplaceid="contract.marketplace_id"
                                           :status="contract.status" :available_invoice_amount="contract.available_invoice_amount"></marketplace-payment-terms>
                <marketplace-contract-documents :contractid="contractid" :marketplaceid="contract.marketplace_id"
                                                :status="contract.status"></marketplace-contract-documents>
            </div>
            <div class="col-md-4">
                <marketplace-contract-sidebar :contract="contract"></marketplace-contract-sidebar>
            </div>
        </div>
    </div>
</template>

<script>
    import ContractDocument from "../../express/contracts/ContractDocuments";
    import {mapGetters} from "vuex";
    import MarketplaceContractOverview from "./MarketplaceContractOverview";
    import MarketplaceContractItems from "./MarketplaceContractItems";
    import MarketplacePaymentTerms from "./MarketplacePaymentTerms";
    import MarketplaceContractSidebar from "./sidebar/MarketplaceContractSidebar";
    import MarketplaceContractDocuments from "./MarketplaceContractDocuments";
    import DidDetails from "../../common/DidDetails";

    export default {
        name: "ViewMarketplaceContract",
        components: {
            DidDetails,
            MarketplaceContractDocuments,
            MarketplaceContractSidebar,
            MarketplacePaymentTerms,
            MarketplaceContractItems,
            MarketplaceContractOverview,
            ContractDocument
        },
        props: ["contractid"],
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        data() {
            return {
                contract: {
                    type: null,
                    goods_services_specs: [{
                        key: null,
                        value: null
                    }],
                    contract_props: null,
                    attachments: [],
                    expires_at: null,
                    created_at: null,
                    owner: {
                        biz_name: ''
                    },
                    counterparty: {
                        biz_name: ''
                    },
                    goods_services: [],
                    quantity: null,
                    total: null,
                    pricing_terms: {
                        rate: null,
                        method: ''
                    },
                    payment_terms: [],
                    available_invoice_amount: 0
                }
            }
        },
        beforeMount() {
            this.init();
            this.$root.$on('refreshContract', () => {
                this.init();
            })
        },
        methods: {
            async init() {
                await this.getContract();
            },
            async getContract() {
                $(".preloader").fadeIn();
                let reply = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/contracts/${this.contractid}`);
                $(".preloader").fadeOut();
                this.contract = reply.data.contract;
            }
        }
    }
</script>

<style scoped>

</style>
